module.exports = __webpack_public_path__ + "img/bottom_logo.2c438693.svg";